const getRuEnLabel = (ruValue, enValue) => `${ruValue || ''} / ${enValue || ''}`;

const getTagLabel = (tag) => (tag ? getRuEnLabel(tag.ru, tag.en) : '-');

const getTagCategoryLabel = (tag) => (tag ? getRuEnLabel(tag.ru_category, tag.en_category) : '-');

const normalizeValue = (value) => (value || '').toString().toLowerCase().trim();

const matchesSearchTokens = (searchValue, candidates) => {
  const tokens = normalizeValue(searchValue).split(/\s+/).filter(Boolean);

  if (!tokens.length) {
    return true;
  }

  const normalizedCandidates = candidates.map(normalizeValue).filter(Boolean);
  return tokens.every((token) => normalizedCandidates.some((candidate) => candidate.includes(token)));
};

export {
  getRuEnLabel, getTagLabel, getTagCategoryLabel, matchesSearchTokens,
};
